import {
	isColorDark,
	isRGB,
	retrieveLaunchParams
} from '@telegram-apps/sdk-react'
import { AppRoot, Placeholder } from '@telegram-apps/telegram-ui'
import Lottie, { type Options } from 'react-lottie'
import { useMemo } from 'react'
import '@telegram-apps/telegram-ui/dist/styles.css'

export default function ErrorScreen({
	header,
	description,
	lottieAnimationData
}: {
	header: string
	description: string
	lottieAnimationData: object
}) {
	const [platform, isDark, lottieOptions] = useMemo(() => {
		const platform = 'base'
		let isDark = false
		try {
			const lp = retrieveLaunchParams()
			const { bgColor } = lp.themeParams
			isDark = bgColor && isRGB(bgColor) ? isColorDark(bgColor) : false
		} catch {
			/**/
		}

		const lottieOptions: Options = {
			loop: true,
			autoplay: true,
			animationData: lottieAnimationData,
			rendererSettings: {
				preserveAspectRatio: 'xMidYMid slice'
			}
		}

		return [platform, isDark, lottieOptions]
	}, [])

	return (
		<AppRoot
			appearance={isDark ? 'dark' : 'light'}
			platform={['macos', 'ios'].includes(platform) ? 'ios' : 'base'}
		>
			<Placeholder header={header} description={description}>
				<Lottie
					options={lottieOptions}
					height={200}
					width={200}
					isClickToPauseDisabled={true}
				/>
			</Placeholder>
		</AppRoot>
	)
}
